import { ButtonHTMLAttributes, memo } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

interface SelectableCardProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children'
> {
  title: string
  isActive?: boolean
  isSoon?: boolean
  soonLabel?: string
}

export const SelectableCard = memo(
  ({
    title,
    isActive = false,
    isSoon = false,
    soonLabel,
    className,
    disabled,
    onClick,
    ...buttonProps
  }: SelectableCardProps) => {
    const isDisabled = disabled || isSoon

    return (
      <button
        type="button"
        className={clsx(s.card, className, {
          [s.cardSoon]: isSoon,
        })}
        aria-disabled={isDisabled}
        aria-pressed={isSoon ? undefined : isActive}
        onClick={isDisabled ? undefined : onClick}
        {...buttonProps}
      >
        <span className={clsx(s.title, isSoon && s.titleSoon, 'medium-15')}>
          {title}
        </span>

        {isSoon ? (
          <span className={clsx(s.soonBadge, 'medium-14')}>{soonLabel}</span>
        ) : (
          <span
            className={clsx(s.indicator, {
              [s.indicatorActive]: isActive,
            })}
          />
        )}
      </button>
    )
  },
)

SelectableCard.displayName = 'SelectableCard'
